
















import { Vue, Component } from 'vue-property-decorator';
import AList from './a-list.vue';
@Component({
  components: { AList }
})
export default class Scene1 extends Vue {
  bread = [{ name: '客户旅程指标分析驾驶仓' }, { name: '客户旅程分析仪表盘' }];

}
